{
  "catalog": {
    "pages": {
      "title": "Chẩn đoán",
      "permissionDenied": "Bạn không có quyền xem danh mục chẩn đoán."
    },
    "actions": {
      "add": "Thêm chẩn đoán",
      "addService": "Thêm dịch vụ",
      "removeService": "Bỏ dịch vụ gợi ý",
      "export": "Xuất CSV",
      "import": "Nhập file",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "reactivate": "Bật lại",
      "reactivating": "Đang bật lại..."
    },
    "search": {
      "placeholder": "Tìm theo mã, tên hoặc khối..."
    },
    "panel": {
      "blocksTitle": "Khối mã",
      "scopeSection": "Phạm vi",
      "blocksSection": "Danh sách khối",
      "allBlocks": "Tất cả",
      "unassigned": "Chưa gán khối",
      "noBlocks": "Chưa có khối. Thêm khối để nhóm chẩn đoán."
    },
    "filters": {
      "system": "Hệ mã",
      "activeScope": "Đang dùng ({{coding}} + Nội bộ)",
      "legacyScope": "{{coding}} (đã lưu)",
      "allSystems": "Tất cả hệ mã"
    },
    "fields": {
      "system": "Hệ mã",
      "code": "Mã",
      "name": "Tên chẩn đoán",
      "nameEn": "Tên tiếng Anh",
      "block": "Khối",
      "suggestedServices": "Dịch vụ gợi ý",
      "serviceCode": "Mã DV",
      "serviceName": "Tên dịch vụ",
      "servicePrice": "Đơn giá",
      "status": "Trạng thái"
    },
    "systems": {
      "icd10": "ICD-10",
      "icd11": "ICD-11",
      "custom": "Nội bộ"
    },
    "picker": {
      "title": "Chọn dịch vụ gợi ý",
      "select": "Thêm"
    },
    "form": {
      "system": "Hệ mã",
      "code": "Mã chẩn đoán",
      "codePlaceholderIcd10": "Ví dụ: K02.1",
      "codePlaceholderIcd11": "Ví dụ: 1A00.0",
      "codePlaceholderCustom": "Ví dụ: LOCAL-001",
      "name": "Tên chẩn đoán (tiếng Việt)",
      "namePlaceholder": "Ví dụ: Sâu răng",
      "nameEn": "Tên tiếng Anh",
      "nameEnPlaceholder": "Ví dụ: Dental caries",
      "block": "Khối ICD",
      "blockPlaceholder": "Chọn khối chẩn đoán",
      "blockNone": "Không chọn khối",
      "suggestedServices": "Dịch vụ gợi ý",
      "suggestedServicesEmpty": "Chưa chọn dịch vụ gợi ý",
      "suggestedServicesLimit": "{{count}}/{{max}} dịch vụ",
      "systemLockedHint": "Không đổi hệ mã sau khi tạo",
      "systemCodeLockedHint": "Mã chuẩn hệ thống, không sửa mã"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm chẩn đoán",
      "editTitle": "Sửa chẩn đoán",
      "importTitle": "Nhập chẩn đoán",
      "confirmDeactivate": "Ngừng dùng chẩn đoán \"{{name}}\"?"
    },
    "importExport": {
      "hintRequired": "Bắt buộc: hệ mã, mã chẩn đoán, tên. Cột khối là mã khối đã tồn tại cùng hệ mã. Upsert theo system+code. Chỉ cho phép hệ mã đang dùng và Nội bộ.",
      "hintMapping": "Tên cột không cần giống file mẫu — hãy ghép cột sau khi chọn file, rồi bấm Kiểm tra.",
      "hintSheet": "File Excel: chỉ đọc sheet đầu tiên.",
      "chooseFile": "Chọn file CSV hoặc Excel",
      "dropHint": "Nhấn để chọn hoặc kéo thả file CSV hoặc Excel",
      "acceptHint": "CSV hoặc Excel (.xlsx), tối đa 5MB / 5000 dòng. Excel: chỉ đọc sheet đầu.",
      "invalidFile": "Vui lòng chọn file CSV hoặc Excel (.xlsx)",
      "changeFile": "Đổi file",
      "commit": "Nhập dữ liệu",
      "downloadTemplate": "Tải file mẫu",
      "downloadErrors": "Tải dòng lỗi (CSV)",
      "errorsCsvFilename": "chan-doan-loi.csv",
      "noFile": "Vui lòng chọn file CSV hoặc Excel",
      "previewTitle": "Kết quả kiểm tra",
      "total": "Tổng dòng",
      "toCreate": "Sẽ tạo mới",
      "toUpdate": "Sẽ cập nhật",
      "errorsTitle": "Lỗi",
      "row": "Dòng",
      "code": "Mã",
      "message": "Chi tiết",
      "readyToCommit": "File hợp lệ. Bạn có thể nhập dữ liệu.",
      "hasErrors": "File còn lỗi. Sửa rồi kiểm tra lại trước khi nhập.",
      "resultTitle": "Kết quả nhập",
      "created": "Đã tạo",
      "updated": "Đã cập nhật",
      "uploading": "Đang tải file…",
      "checking": "Đang kiểm tra file…",
      "checkingWithCount": "Đang kiểm tra {{count}} dòng…",
      "importing": "Đang nhập dữ liệu…",
      "importingWithCount": "Đang nhập {{count}} dòng…",
      "confirmUpdateTitle": "Xác nhận cập nhật",
      "confirmUpdateMessage": "Sẽ cập nhật {{count}} chẩn đoán hiện có. Tiếp tục?",
      "confirmUpdateConfirm": "Cập nhật",
      "fields": {
        "system": "Hệ mã",
        "code": "Mã chẩn đoán",
        "name": "Tên chẩn đoán",
        "nameEn": "Tên tiếng Anh",
        "block": "Mã khối",
        "suggestedServiceCodes": "Dịch vụ gợi ý",
        "isActive": "Đang dùng"
      },
      "rowErrors": {
        "SYSTEM_INVALID": "Hệ mã phải là \"{{system}}\" hoặc \"custom\".",
        "CODE_REQUIRED": "Thiếu mã chẩn đoán.",
        "CODE_FORMAT_INVALID": "Mã không đúng định dạng hệ \"{{system}}\".",
        "NAME_REQUIRED": "Thiếu tên chẩn đoán.",
        "IS_ACTIVE_INVALID": "Cột isActive phải là true hoặc false.",
        "DUPLICATE_SYSTEM_CODE": "Trùng hệ mã + mã chẩn đoán trong file.",
        "BLOCK_FORMAT_INVALID": "Mã khối không đúng định dạng: {{value}}.",
        "BLOCK_UNKNOWN": "Không tìm thấy mã khối {{block}}.",
        "SUGGESTED_SERVICES_UNKNOWN": "Không tìm thấy mã dịch vụ gợi ý: {{codes}}.",
        "SUGGESTED_SERVICES_TOO_MANY": "Tối đa {{max}} dịch vụ gợi ý.",
        "SUGGESTED_SERVICES_INVALID": "Danh sách dịch vụ gợi ý không hợp lệ."
      }
    },
    "table": {
      "empty": "Chưa có chẩn đoán",
      "noFound": "Không tìm thấy chẩn đoán phù hợp",
      "createdAt": "Ngày tạo",
      "updatedAt": "Cập nhật lần cuối",
      "createdBy": "Người tạo",
      "updatedBy": "Người cập nhật",
      "recordKind": "Nguồn mã"
    },
    "type": {
      "system": "Hệ thống",
      "custom": "Tự tạo"
    },
    "validation": {
      "codeRequired": "Vui lòng nhập mã chẩn đoán",
      "codeInvalid": "Mã không đúng định dạng hệ mã đã chọn",
      "nameRequired": "Vui lòng nhập tên chẩn đoán",
      "suggestedServicesMax": "Tối đa {{max}} dịch vụ gợi ý"
    },
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử",
      "empty": "Chưa có lịch sử thay đổi cho chẩn đoán này."
    },
    "toasts": {
      "created": "Đã thêm chẩn đoán",
      "updated": "Đã cập nhật chẩn đoán",
      "deactivated": "Đã ngừng dùng chẩn đoán",
      "reactivated": "Đã bật lại chẩn đoán",
      "saveFailed": "Không lưu được chẩn đoán",
      "deactivateFailed": "Không ngừng dùng được chẩn đoán",
      "reactivateFailed": "Không bật lại được chẩn đoán",
      "loadFailed": "Không tải được danh mục chẩn đoán",
      "serviceAlreadyAdded": "Dịch vụ này đã được thêm",
      "suggestedServicesMax": "Đã đạt tối đa {{max}} dịch vụ gợi ý",
      "exported": "Đã xuất CSV",
      "exportFailed": "Không xuất được CSV",
      "imported": "Đã nhập chẩn đoán thành công",
      "importFailed": "Không nhập được file",
      "templateFailed": "Không tải được file mẫu"
    }
  },
  "blocks": {
    "pages": {
      "title": "Khối chẩn đoán",
      "permissionDenied": "Bạn không có quyền xem danh mục khối chẩn đoán."
    },
    "actions": {
      "add": "Thêm khối",
      "manage": "Quản lý",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "reactivate": "Bật lại",
      "delete": "Xóa hẳn",
      "deleting": "Đang xóa..."
    },
    "search": {
      "placeholder": "Tìm theo mã hoặc tên khối..."
    },
    "filters": {
      "system": "Hệ mã",
      "activeScope": "Đang dùng ({{coding}} + Nội bộ)",
      "legacyScope": "{{coding}} (đã lưu)",
      "allSystems": "Tất cả hệ mã"
    },
    "fields": {
      "system": "Hệ mã",
      "code": "Mã khối",
      "name": "Tên khối",
      "nameEn": "Tên tiếng Anh",
      "status": "Trạng thái",
      "codeCount": "Số mã",
      "createdAt": "Ngày tạo"
    },
    "form": {
      "system": "Hệ mã",
      "code": "Mã khối",
      "codePlaceholder": "Ví dụ: K00-K14",
      "name": "Tên khối (tiếng Việt)",
      "namePlaceholder": "Ví dụ: Bệnh răng và môi",
      "nameEn": "Tên tiếng Anh",
      "nameEnPlaceholder": "Ví dụ: Diseases of oral cavity"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm khối chẩn đoán",
      "editTitle": "Sửa khối chẩn đoán",
      "manageTitle": "Quản lý khối chẩn đoán",
      "confirmDeactivate": "Ngừng dùng khối \"{{name}}\"?",
      "confirmDelete": "Xóa hẳn khối \"{{name}}\"? Thao tác không thể hoàn tác."
    },
    "errors": {
      "systemBlock": "Không thể xóa khối hệ thống. Bạn có thể ngừng dùng trong form sửa.",
      "inUse": "Khối đang có {{count}} mã chẩn đoán. Hãy chuyển hoặc bỏ gán mã trước khi xóa hẳn."
    },
    "history": {
      "empty": "Chưa có lịch sử thay đổi cho khối này."
    },
    "table": {
      "empty": "Chưa có khối chẩn đoán",
      "noFound": "Không tìm thấy khối phù hợp"
    },
    "validation": {
      "codeRequired": "Vui lòng nhập mã khối",
      "codeInvalid": "Mã khối không đúng định dạng",
      "nameRequired": "Vui lòng nhập tên khối"
    },
    "toasts": {
      "created": "Đã thêm khối chẩn đoán",
      "updated": "Đã cập nhật khối chẩn đoán",
      "deactivated": "Đã ngừng dùng khối chẩn đoán",
      "reactivated": "Đã bật lại khối chẩn đoán",
      "deleted": "Đã xóa khối chẩn đoán",
      "saveFailed": "Không lưu được khối chẩn đoán",
      "deactivateFailed": "Không ngừng dùng được khối chẩn đoán",
      "reactivateFailed": "Không bật lại được khối chẩn đoán",
      "deleteFailed": "Không xóa được khối chẩn đoán",
      "loadFailed": "Không tải được danh mục khối chẩn đoán"
    }
  }
}
